import { buildPublicSiteUrl } from "@/lib/site-url";

export const AUTH_FLOW_QUERY_PARAM = "auth_flow";

export const AUTH_FLOWS = [
  "password_signup",
  "magic_signup",
  "magic_signin",
  "magic_link_settings",
  "password_recovery",
] as const;

export type AuthFlow = (typeof AUTH_FLOWS)[number];

export function isAuthFlow(value: string | null): value is AuthFlow {
  return AUTH_FLOWS.includes(value as AuthFlow);
}

export function buildAuthFlowRedirectUrl(
  path: string,
  flow: AuthFlow,
  windowOrigin?: string,
) {
  const redirectUrl = new URL(buildPublicSiteUrl(path, windowOrigin));
  redirectUrl.searchParams.set(AUTH_FLOW_QUERY_PARAM, flow);
  return redirectUrl.toString();
}


export const API_KEY_DESTINATION = "/account/keys";
export function safeAccountDestination(value: string | null | undefined, fallback = "/account") {
  if (!value || !value.startsWith("/") || value.startsWith("//") || /[\\\s]/.test(value)) return fallback;
  try {
    const url = new URL(value, "https://deepface.dev");
    if (url.origin !== "https://deepface.dev" || !(url.pathname === "/oauth/authorize" || url.pathname === "/sessions" || url.pathname === "/account" || url.pathname.startsWith("/account/"))) return fallback;
    const promptHash = url.pathname === API_KEY_DESTINATION && /^#agent-(first-request|verification|production)$/.test(url.hash) ? url.hash : "";
    return url.pathname + url.search + promptHash;
  } catch { return fallback; }
}

export function accountSignInPath(pathname:string, hash="") {
  return `/signin?next=${encodeURIComponent(safeAccountDestination((pathname || "/account") + hash))}`;
}
